/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useEffect, useState } from "react";
import { getData } from "../Services/getData";
import { urlEnum } from "../Utils/urlEnum";
import createConnectionForWebsocket from "../Utils/utils";

export const NotificationsContext = createContext<any>({
  notifications: [],
  notificationCount: 0,
  allUserUnreadNotifications: [],
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  getNotificationsForUser: () => {},
});

export const NotificationsContextProvider = (props: any) => {
  const [notificationCount, setNotificationCount] = useState<number>(0);
  const [notifications, setNotifications] = useState<any[]>([]);
  const [allUserUnreadNotifications, setAllUnreadUserNotifications] = useState<
    any[]
  >([]);

  const getNotificationsForUser = () => {
    getData(`${urlEnum.notifications}/${localStorage.getItem("useId")}`).then(
      (res) => {
        if (res) {
          setNotifications(res.data.notifications);
          setNotificationCount(res.data.notificationsNumber);
          setAllUnreadUserNotifications(res.data?.unreadNotifications);
        }
      }
    );
  };

  useEffect(() => {
    getNotificationsForUser();
  }, []);

  // subscribes once for the lifetime of the session, instead of once per
  // route navigation, since this provider sits above the router and is
  // never remounted while the user stays logged in
  useEffect(() => {
    const pusher = createConnectionForWebsocket();
    const channel = pusher.subscribe(
      `private-notifications.${localStorage.getItem("useId")}`
    );
    channel.bind("send-notifications", (data: any) => {
      getNotificationsForUser();
      if (data?.notification?.message) {
        new Notification(data?.notification?.message || "");
        const audio = new Audio("/notificare.mp3");
        audio.play().catch(() => {/* autoplay blocked before user interaction */});
      }
    });

    const cacheChannel = pusher.subscribe("cache-refresh");

    const isFirstVisit = sessionStorage.getItem("isFirstVisit");
    if (!isFirstVisit) {
      sessionStorage.setItem("isFirstVisit", "true");

      cacheChannel.bind("pusher:subscription_succeeded", async () => {
        const cacheDataResponse = await getData(`${urlEnum.cacheData}/null`);
        if (cacheDataResponse && cacheDataResponse.data) {
          localStorage.setItem(
            "cacheData",
            JSON.stringify(cacheDataResponse.data)
          );
        }
      });
    }

    cacheChannel.bind("cache-refresh", async () => {
      const cacheDataResponse = await getData(`${urlEnum.cacheData}/null`);
      if (cacheDataResponse && cacheDataResponse.data) {
        localStorage.setItem(
          "cacheData",
          JSON.stringify(cacheDataResponse.data)
        );
        const permissionsName: any = [];
        cacheDataResponse?.data?.permissions?.forEach((element: any) => {
          permissionsName.push(element.name);
        });
        localStorage.setItem("permissions", permissionsName);
        const rolesName: any = [];
        cacheDataResponse?.data?.userRole?.forEach((element: any) => {
          rolesName.push(element.name);
        });
        localStorage.setItem("roles", rolesName);
      }
    });

    return () => {
      pusher.unsubscribe(`private-notifications.${localStorage.getItem("useId")}`);
      pusher.unbind("send-notifications");
      pusher.unsubscribe("cache-refresh");
      pusher.unbind("cache-refresh");
      pusher.unbind("pusher:subscription_succeeded");
    };
  }, []);

  return (
    <NotificationsContext.Provider
      value={{
        notifications,
        notificationCount,
        allUserUnreadNotifications,
        getNotificationsForUser,
      }}
    >
      {props.children}
    </NotificationsContext.Provider>
  );
};
